import React, { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { X } from 'lucide-react';
import StepIndicator from './StepIndicator';
import PersonalDetailsStep from './PersonalDetailsStep';
import HealthInfoStep from './HealthInfoStep';
import MembershipInfoStep from './MembershipInfoStep';
import AccessSetupStep from './AccessSetupStep';
import ConfirmationStep from './ConfirmationStep';
import { getPlans, getUsers } from '../../data/mockData';
import api from '../../services/ApiService';
import { ENDPOINTS } from '../../constant/ApiEndpoints';
import toast from 'react-hot-toast';
import useDidFetch from '../../custom_hooks/useDidfetch';

const steps = [
    { name: 'Personal' },
    { name: 'Health' },
    { name: 'Membership' },
    // { name: 'Access' },
    { name: 'Confirm' },
];

const MemberRegistrationWizard = ({ isOpen, onClose, onSuccess, initialData, conversionData, confirmBtnLoading }) => {
    const [currentStep, setCurrentStep] = useState(0);
    const [plans, setPlans] = useState([]);
    const [users, setUsers] = useState([]);
    const [trainers, setTrainers] = useState([]);
    const [formData, setFormData] = useState({
        personal: {},
        health: {},
        membership: {},
        // access: {},
    });;
    console.log("initialData-->>");
    console.log(initialData);
    
    useEffect(() => {
        if (isOpen) {
            // Reset form when opening
            setCurrentStep(0);
            const initialPersonal = {
                name: initialData?.name || '',
                email: initialData?.email || '',
                contact: initialData?.contact || initialData?.phone || '',
                dob: initialData?.meta?.dob || '',
                gender: initialData?.meta?.gender || 'Male',
                address: initialData?.meta?.address || '',
                emergencyContactName: initialData?.meta?.emergency_contact_name || '',
                emergencyContactPhone: initialData?.meta?.emergency_contact_number || '',
                image_base64: "",
            };
            const initialMembership = {
                planId: initialData?.plan?.id || '',
                assignedTrainer: initialData?.meta?.trainer_assigned || null,
                trainer_name: initialData?.trainer?.name || null,
                startDate:initialData?.start_date ?? new Date().toISOString().split('T')[0],
                endDate: '',
                userStatus: initialData?.status ?? 'inactive'
            };
            setFormData({
                id: initialData?.id || '',
                enq_id: initialData?.enq_id || '',
                personal: initialPersonal,
                health: {
                    height: initialData?.meta?.height_cm || '',
                    weight: initialData?.meta?.weight_kg || '',
                    level: initialData?.meta?.fitness_level || 'Beginner',
                    conditions: initialData?.meta?.medical_conditions || '',
                    goals: initialData?.meta?.fitness_goals || ''
                },
                membership: initialMembership,
                // access: { type: conversionData?.accessType || 'RFID', status: 'Active', notes: '' },
            });
        }
        console.log(initialData);

    }, [isOpen, initialData, conversionData]);

    const runOnce = useDidFetch();
    useEffect(() => {
        runOnce(() => {
            getAllPlans();
            getAllUser();
            getTrainers()
        })
    }, [])
    const getAllPlans = async () => {
        try {
            // setIsLoading(true);
            const response = await api.get(ENDPOINTS.getPlan);
            const result = response?.data;
            if (response.status === 200 || response.status === 201) {
                setPlans(result ?? []);
            }
        } catch (error) {
            console.error("plans get error:", error);
        } finally {
            // setIsLoading(false);
        }
    }
    const getAllUser = async () => {
        try {
            // setIsLoading(true);
            const response = await api.get(ENDPOINTS.getUser);
            const result = response?.data;
            console.log(response);
            if (response.status === 200) {
                setUsers(result?.users ?? []);
                // const trainers = result?.users.filter(u => u.role?.name == 'trainer');
                // console.log(trainers);
                // setTrainers(trainers);
            }
        } catch (error) {
            console.error("user get error:", error);
        } finally {
            // setIsLoading(false);
        }
    }
    const getTrainers = async () => {
        try {
            // setIsLoading(true);
            const response = await api.get(`${ENDPOINTS.getUserByRole}/trainer`);
            const result = response?.data;
            console.log(response);
            if (response.status === 200) {
                setTrainers(result?.users ?? []);
            }
        } catch (error) {
            console.error("getMembers error:", error);
        } finally {
            // setIsLoading(false);
        }
    }
    const handleNext = (data) => {
        setFormData(prev => ({ ...prev, ...data }));
        if (currentStep < steps.length - 1) {
            setCurrentStep(currentStep + 1);
        }

        console.log("data=====>>>", data);
    };

    const handleBack = () => {
        if (currentStep > 0) {
            setCurrentStep(currentStep - 1);
        }
    };

    const handleConfirm = () => {
        const newMember = {
            // id: `USR-${Date.now()}`,
            ...formData,
        };
        onSuccess(newMember);
    };

    const renderStep = () => {
        switch (currentStep) {
            case 0:
                return <PersonalDetailsStep data={formData.personal} onNext={handleNext} />;
            case 1:
                return <HealthInfoStep data={formData.health} onNext={handleNext} onBack={handleBack} />;
            case 2:

                return <MembershipInfoStep isEdit={!!initialData?.id}  data={formData} onNext={handleNext} onBack={handleBack} trainers={trainers} plans={plans} />;
            // case 3:
            //     return <AccessSetupStep data={formData.access} onNext={handleNext} onBack={handleBack} />;
            case 3:
                return <ConfirmationStep isLoading={confirmBtnLoading} data={formData} trainers={trainers} onConfirm={handleConfirm} onBack={handleBack} plans={plans} />;
            default:
                return null;
        }
    };

    const backdropVariants = { visible: { opacity: 1 }, hidden: { opacity: 0 } };
    const modalVariants = {
        hidden: { y: "50px", opacity: 0 },
        visible: { y: "0", opacity: 1, transition: { type: "spring", stiffness: 300, damping: 30 } },
        exit: { y: "50px", opacity: 0 },
    };

    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4"
                    variants={backdropVariants} initial="hidden" animate="visible" exit="hidden"
                >
                    <motion.div
                        className="bg-gray-50 rounded-xl shadow-2xl w-full max-w-3xl flex flex-col h-[90vh]"
                        variants={modalVariants} onClick={(e) => e.stopPropagation()}
                    >
                        <div className="flex justify-between items-center p-4 sm:p-6 border-b border-gray-200 bg-white rounded-t-xl">
                            <h3 className="text-xl font-bold font-display text-gray-800">{initialData?.id != null ? 'Edit Member' : 'New Member Registration'}</h3>
                            <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition"><X size={24} /></button>
                        </div>
                        <div className="p-4 sm:p-6">
                            <StepIndicator steps={steps} currentStep={currentStep} />
                        </div>
                        <div className="flex-1 overflow-y-auto p-4 sm:p-6">
                            {renderStep()}
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default MemberRegistrationWizard;
